var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dis-f flex-column",attrs:{"id":"app"}},[_c('toast'),_c('router-view',{staticClass:"flex1"}),(_vm.$route.meta.showMenu)?_c('footerMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }